/*判断终端*/
const uaCheck = function() {
  var U = window.navigator.userAgent
  var u = U.toLowerCase()
  var ua = {}
  ua.isAndroid =
    U.indexOf('Android') > -1 ||
    U.indexOf('android') > -1 ||
    u.indexOf('Adr') > -1 //android终端
  ua.isIOS =
    !!U.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ||
    !!U.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i) //ios终端
  ua.isWechat = u.match(/MicroMessenger/i) == 'micromessenger' //微信浏览器
  ua.isFirefox = u.indexOf('firefox') > -1 //火狐浏览器
  ua.isOpera = u.indexOf('opera') > -1 || u.indexOf('opr') > -1 //Opera 浏览器
  return ua
}
const isMobile = function() {
  let innerWidth = document.body.clientWidth
  if (innerWidth <= 800) {
    return true
  } else {
    return false
  }
}
/*键盘离开事件页面优化*/
const focusout = function() {
  document.body.addEventListener('focusout', () => {
    let ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('iphone') > 0 || ua.indexOf('ipad') > 0) {
      setTimeout(() => {
        const scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    }
  })
}

export default {
  uaCheck,
  focusout,
  isMobile
}
